import { useMessageNewSocketListener } from '../hooks/useMessageNewSocketListener';
import { useMessageReactionSocketListener } from '../hooks/useMessageReactionSocketListener';
import { usePartnerGroupChatSocketListener } from '../hooks/usePartnerGroupChatSocketListener';
import { usePartnerTemporaryDisableSocketListener } from '../hooks/usePartnerTemporaryDisableSocketListener';

/** Mounts Socket.IO chat handlers (no UI). */
const PartnerSocketListeners = ({ enabled = true }) => {
  usePartnerGroupChatSocketListener({ enabled });
  useMessageNewSocketListener({ enabled });
  useMessageReactionSocketListener({ enabled });
  usePartnerTemporaryDisableSocketListener({ enabled });
  return null;
};

export default PartnerSocketListeners;
